// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  DateCell,
  ActionsCell,
  CustomHeader
} from '@/components/table/columns'
import  { OperationCell, CreditCell, StatusCell } from './StatementCells'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title="Operation" className='min-w-125px' />,
  id: 'type',
  Cell: ({...props}) => (
    <OperationCell
      type={props.data[props.row.index].type}
      trx={props.data[props.row.index].transaction}
      order={props.data[props.row.index].order}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Status" className='min-w-75px' />,
  id: 'Status',
  Cell: ({...props}) => (
    <StatusCell
      type={props.data[props.row.index].type}
      status={props.data[props.row.index].statuses.at(-1).status}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Date" className='min-w-75px' />,
  id: 'date',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Code' className='min-w-125px text-end pe-0' />,
  id: 'code',
  className: 'text-end pe-0',
  Cell: ({...props}) => (
    <TextCell
      content={props.data[props.row.index]?.order?.voucher?.code || props.data[props.row.index]?.transaction?.code || ''}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Credit' className='min-w-125px text-center pe-0' />,
  id: 'credit',
  className: 'text-center pe-0',
  Cell: ({...props}) => (
    <CreditCell
      credit={props.data[props.row.index].credit}
      debit={props.data[props.row.index].debit}
      type={props.data[props.row.index].type}
      status={props.data[props.row.index].statuses.at(-1).status}
    />
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => {
    const row = props.data[props.row.index]
    const actions = []
    if (['payment', 'order', 'exceptional_credits'].includes(row.type)) {
      actions.push({
        icon: 'exit-right-corner',
        label: 'Details',
        openModal: 'details'
      })
    } else if (row.parent) {
      actions.push({
        icon: 'exit-up',
        label: 'Parent',
        openModal: 'parent-details'
      })
    }

    if (actions.length > 0) {
      return (
        <ActionsCell
          itemForUpdate={props.data[props.row.index]}
          actions={actions}
        />
      )
    }

    return (<></>)
  }
}]

export {Columns}
